export const __TicketPill = ({ status, clicked }) => ({
	height: 30,
	minWidth: 84,
	borderRadius: 5,
	border: '1px solid #0078ff',
	color: '#0078ff',
	display: 'inline-block',
	margin: 5,
	fontSize: 14,
	width: 'auto',
	fontWeight: 'bold',
	background: '#fff',

	extend: [
		{
			condition: status,
			style: {
				background: '#ddd',
				pointerEvents: 'none',
			},
		},
		{
			condition: clicked,
			style: {
				color: '#000',
				background: '#0078ff',
			},
		},
	],
})
